/**
 * Render mínimo de markdown para las respuestas del asistente: negrita,
 * cursiva, código inline, listas, encabezados y tablas simples. Escapa el HTML
 * primero, así lo que devuelve el modelo nunca se inyecta como markup.
 */
function escapar(texto) {
  return String(texto).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}

function inline(texto) {
  return texto
    .replace(/`([^`]+)`/g, "<code>$1</code>")
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|[^*])\*([^*\n]+)\*/g, "$1<em>$2</em>");
}

function tabla(lineas) {
  const filas = lineas
    .map((l) => l.trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim()))
    .filter((celdas, i) => !(i === 1 && celdas.every((c) => /^:?-{2,}:?$/.test(c))));
  if (!filas.length) return "";
  const [cabecera, ...cuerpo] = filas;
  const th = cabecera.map((c) => `<th>${inline(c)}</th>`).join("");
  const tr = cuerpo.map((f) => `<tr>${f.map((c) => `<td>${inline(c)}</td>`).join("")}</tr>`).join("");
  return `<table><thead><tr>${th}</tr></thead><tbody>${tr}</tbody></table>`;
}

export function renderMarkdown(texto) {
  const lineas = escapar(texto || "").split("\n");
  const salida = [];
  let lista = null; // "ul" | "ol"
  let bufferTabla = [];
  let parrafo = [];

  const cerrarLista = () => { if (lista) { salida.push(`</${lista}>`); lista = null; } };
  const cerrarTabla = () => { if (bufferTabla.length) { salida.push(tabla(bufferTabla)); bufferTabla = []; } };
  const cerrarParrafo = () => { if (parrafo.length) { salida.push(`<p>${inline(parrafo.join("<br>"))}</p>`); parrafo = []; } };

  for (const linea of lineas) {
    const l = linea.trimEnd();
    if (/^\s*\|.*\|\s*$/.test(l)) { cerrarLista(); cerrarParrafo(); bufferTabla.push(l); continue; }
    cerrarTabla();
    const h = l.match(/^(#{1,3})\s+(.*)$/);
    if (h) { cerrarLista(); cerrarParrafo(); salida.push(`<h${h[1].length + 3}>${inline(h[2])}</h${h[1].length + 3}>`); continue; }
    const li = l.match(/^\s*([-*]|\d+[.)])\s+(.*)$/);
    if (li) {
      cerrarParrafo();
      const tipo = /\d/.test(li[1]) ? "ol" : "ul";
      if (lista !== tipo) { cerrarLista(); salida.push(`<${tipo}>`); lista = tipo; }
      salida.push(`<li>${inline(li[2])}</li>`);
      continue;
    }
    cerrarLista();
    if (!l.trim()) { cerrarParrafo(); continue; }
    parrafo.push(l.trim());
  }
  cerrarTabla(); cerrarLista(); cerrarParrafo();
  return salida.join("");
}
